<template>
  <Transition
    enter-active-class="transition-all duration-500"
    leave-active-class="transition-all duration-300"
    enter-from-class="scale-90 opacity-0"
    leave-to-class="scale-75 opacity-0">
    <div class="w-full p-4 rounded-md shadow-xs" :class="backgroundClass[level]" v-if="!dismissed">
      <div class="flex w-full">
        <div class="shrink-0">
          <i class="fa-fw fa-sharp" :class="iconClass[level]" aria-hidden="true" />
        </div>
        <div class="grow ml-3">
          <h3 class="mb-2 text-sm font-semibold" :class="`${headingClass[level]} ${headingPosition}`" v-if="heading">
            {{ heading }}
          </h3>
          <div class="text-sm" :class="textClass[level]">
            <slot />

            <div v-if="$slots.well" class="p-3 mt-3 rounded-sm" :class="wellClass[level]">
              <slot name="well" />
            </div>

            <div v-if="$slots.actions" class="flex flex-wrap justify-end gap-3 mt-3">
              <slot name="actions" />
            </div>
          </div>
        </div>
        <div class="pl-3 ml-auto" v-if="dismissable">
          <div class="-mx-1.5 -my-1.5">
            <button
              type="button"
              class="inline-flex rounded-md p-1.5 focus:outline-hidden focus:ring-2 focus:ring-offset-2"
              :class="dismissClass[level]"
              @click="dismiss">
              <span class="sr-only">Dismiss</span>
              <i class="fa-fw fa-sharp fa-regular fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  emits: ['dismissed'],
  props: {
    level: {
      type: String,
      default: 'info'
    },
    heading: {
      type: String,
      default: null
    },
    headingPosition: {
      type: String,
      default: 'justify-self-start'
    },
    dismissable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dismissed: false,
      backgroundClass: {
        info: 'bg-blue-100 dark:bg-blue-900',
        success: 'bg-green-100 dark:bg-green-900',
        warning: 'bg-yellow-100 dark:bg-yellow-900',
        danger: 'bg-red-100 dark:bg-red-900',
        notice: 'bg-gray-100 dark:bg-gray-900'
      },
      iconClass: {
        info: 'fa-info-circle text-blue-600 dark:text-blue-400',
        success: 'fa-check-circle text-green-600 dark:text-green-400',
        warning: 'fa-exclamation-triangle text-yellow-600 dark:text-yellow-400',
        danger: 'fa-times-circle text-red-600 dark:text-red-400',
        notice: null
      },
      headingClass: {
        info: 'text-blue-900 dark:text-blue-200',
        success: 'text-green-900 dark:text-green-200',
        warning: 'text-yellow-900 dark:text-yellow-200',
        danger: 'text-red-900 dark:text-red-200',
        notice: 'text-gray-900 dark:text-gray-200'
      },
      textClass: {
        info: 'text-blue-900 dark:text-blue-300',
        success: 'text-green-900 dark:text-green-300',
        warning: 'text-yellow-900 dark:text-yellow-300',
        danger: 'text-red-900 dark:text-red-300',
        notice: 'text-gray-900 dark:text-gray-300'
      },
      wellClass: {
        info: 'bg-blue-50 dark:bg-blue-950',
        success: 'bg-green-50 dark:bg-green-950',
        warning: 'bg-yellow-50 dark:bg-yellow-950',
        danger: 'bg-red-50 dark:bg-red-950',
        notice: 'bg-gray-50 dark:bg-gray-950'
      },
      dismissClass: {
        info: 'bg-blue-100 text-blue-600 hover:bg-blue-200 focus:ring-blue-600 focus:ring-offset-blue-50 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-700 dark:focus:ring-blue-300 dark:focus:ring-offset-blue-900',
        success:
          'bg-green-100 text-green-600 hover:bg-green-200 focus:ring-green-600 focus:ring-offset-green-50 dark:bg-green-900 dark:text-green-300 dark:hover:bg-green-700 dark:focus:ring-green-300 dark:focus:ring-offset-green-900',
        warning:
          'bg-yellow-100 text-yellow-600 hover:bg-yellow-200 focus:ring-yellow-600 focus:ring-offset-yellow-50 dark:bg-yellow-900 dark:text-yellow-300 dark:hover:bg-yellow-700 dark:focus:ring-yellow-300 dark:focus:ring-offset-yellow-900',
        danger:
          'bg-red-100 text-red-600 hover:bg-red-200 focus:ring-red-600 focus:ring-offset-red-50 dark:bg-red-900 dark:text-red-300 dark:hover:bg-red-700 dark:focus:ring-red-300 dark:focus:ring-offset-red-900',
        notice:
          'bg-gray-100 text-gray-600 hover:bg-gray-200 focus:ring-gray-600 focus:ring-offset-gray-50 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:focus:ring-gray-300 dark:focus:ring-offset-gray-900'
      }
    }
  },
  methods: {
    dismiss() {
      this.dismissed = true
      this.$emit('dismissed')
    }
  }
}
</script>
